import { render, staticRenderFns } from "./email-expired-page.vue?vue&type=template&id=36780319&scoped=true"
import script from "./email-expired-page.vue?vue&type=script&lang=ts"
export * from "./email-expired-page.vue?vue&type=script&lang=ts"
import style0 from "./email-expired-page.vue?vue&type=style&index=0&id=36780319&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36780319",
  null
  
)

export default component.exports